import Float from "./Float.svelte";
import { SvelteComponent } from "svelte";
import { Utils } from "@h4x/common";
import StaticFloat from "./StaticFloat.svelte";
export function float(element, options) {
    let floatingUIComponent;
    let parentElement = element;
    parentElement.id = !parentElement.id ? Utils.generateHID() : parentElement.id;
    const id = options.id ?? Utils.generateHID();
    if (!floatingUIComponent) {
        floatingUIComponent = new Float({
            props: {
                id,
                store: options.store,
                offsetX: options.offsetX,
                offsetY: options.offsetY,
                autoDismiss: options.autoDismiss,
                parentElementId: parentElement.id,
                props: options.props,
                component: options.component,
                shadow: options.shadow ?? true
            },
            target: document.body
        });
    }
    options.store.set(id);
}
export function staticFloat(options) {
    let floatingUIComponent;
    const id = options.id ?? Utils.generateHID();
    if (!floatingUIComponent) {
        floatingUIComponent = new StaticFloat({
            props: {
                id,
                store: options.store,
                autoDismiss: options.autoDismiss,
                props: options.props,
                component: options.component,
                left: options.left,
                right: options.right,
                top: options.top,
                bottom: options.bottom,
                stayOnScreen: options.stayOnScreen,
                shadow: options.shadow ?? true
            },
            target: document.body
        });
    }
    options.store.set(id);
}
